import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { AuthProvider } from "./context/AuthContext";
import { ColorModeProvider } from "./context/ThemeContext";
import { store } from "./redux/store";
import "./index.css";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme/theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ColorModeProvider>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Provider store={store}>
          <AuthProvider>
            <CssBaseline />
            <App />
          </AuthProvider>
        </Provider>
      </BrowserRouter>
    </ThemeProvider>
  </ColorModeProvider>
);
